/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';

import styled from 'styled-components';

import { withStyles } from '@material-ui/core/styles';
import { asField } from 'informed';

import HtmlTooltip from './HtmlTooltip';

// import moment from 'moment';

const StyledFormControl = styled(FormControl)`
  width: 100%;
`;

class DatePickerFieldComponent extends Component {
  constructor(props) {
    super(props);
    this.selectRef = React.createRef();
  }

  handleChange = e => {
    const { fieldApi, onChange } = this.props;
    if (fieldApi.setValue) fieldApi.setValue(e.target.value);

    if (onChange) {
      onChange(e.target.value);
    }
  };

  render() {
    const { fieldApi, fieldState, ...props } = this.props;
    const { value } = fieldState;
    const { setTouched } = fieldApi;
    const {
      classes,
      onChange,
      onBlur,
      field,
      defaultValue,
      multiple,
      shrink,
      label = '',
      //   name = "default_name",
      id = String(Math.floor(Math.random() * 1e8)),
      helperText = '',
      forwardedRef,
      tooltip,
      ...rest
    } = props;
    return (
      <div className={classes.container}>
        <>
          {tooltip && (
            <HtmlTooltip title={tooltip}>
              <span className="helper">?</span>
            </HtmlTooltip>
          )}
          <StyledFormControl error={!!fieldState.error}>
            <TextField
              {...rest} // eslint-disable-line react/jsx-props-no-spreading
              type="date"
              name={field}
              label={label}
              defaultValue={defaultValue}
              ref={this.selectRef}
              value={value || ''}
              InputLabelProps={{ shrink }}
              onChange={this.handleChange}
              onBlur={e => {
                setTouched();
                if (onBlur) {
                  onBlur(e);
                }
              }}
              // material-ui props
              inputProps={{
                //   name,
                id,
              }}
            />
            <FormHelperText>{fieldState.error || helperText}</FormHelperText>
          </StyledFormControl>
        </>
      </div>
    );
  }
}

DatePickerFieldComponent.propTypes = {
  classes: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  tooltip: PropTypes.string,
};

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
});

export default withStyles(styles)(asField(DatePickerFieldComponent));
